// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../css-loader/index.js??ref--5-2!../../../../postcss-loader/lib/index.js??ref--5-3!./styles.css");
if(typeof content === 'string') content = [[module.id, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = require("!../../../../style-loader/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js??ref--5-2!../../../../postcss-loader/lib/index.js??ref--5-3!./styles.css", function() {
			var newContent = require("!!../../../../css-loader/index.js??ref--5-2!../../../../postcss-loader/lib/index.js??ref--5-3!./styles.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/pagination/styles.css
// module id = 1992
// module chunks = 0 6 7 9 10 11 12 14